module.exports = __webpack_public_path__ + "assets/img/00021.92d3bb74.png";